module.exports = __webpack_public_path__ + "img/pop_home_tie@2x.7f0cbd15.png";